import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetSitesOptIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/GetSitesOptIncidents`,
	params: { userId, role }
});

export const GetSiteOptIncidentDetailsRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/GetSiteOptIncidentDetails`,
	params: { userId, tableId }
});

export const GetSiteOptIncidentDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/GetSiteOptIncidentDropdowns`
});

export const EditSiteOptIncidentDetailsRequest = (siteOptimizationsDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteOptimizations/EditSiteOptIncidentDetails`,
	data: siteOptimizationsDto
});

export const CreateSiteOptIncidentRequest = (siteOptimizationsDto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteOptimizations/CreateSiteOptIncident`,
	data: siteOptimizationsDto
});

export const DeleteSiteOptIncidentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/DeleteSiteOptIncident`,
	params: { userId, tableId }
});

export const ExportSitesOptIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/ExportSitesOptIncidents`,
	params: { userId, role }
});

export const GetAutocompleteFieldsRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/GetAutocompleteFields`,
	params: { siteId }
});

export const GetDriveTestsCitiesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/GetDriveTestsCities`,
});

export const GetDriveTestsDrivesRequest = (city) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/GetDriveTestsDrives`,
	params: { city }
});

export const GetDriveTestsDatesRequest = (city, drive) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteOptimizations/GetDriveTestsDates`,
	params: { city, drive }
});

export const GetFailuresRequest = (selectedCity, selectedDates) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteOptimizations/GetFailures`,
	data: { selectedCity, selectedDates }
});

export const AddAttachmentRequest = (userId, incidentId, tempFilePath) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteOptimizations/AddAttachment`,
	data: { userId, incidentId, tempFilePath }
});

export const DownloadAttachmentRequest = (userId, tableId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteOptimizations/DownloadAttachment`,
	params: { userId, tableId }
});

export const RemoveAttachmentRequest = (userId, tableId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}SiteOptimizations/RemoveAttachment`,
	params: { userId, tableId }
});
